import { useNavigate } from 'react-router-dom';

export default function HowItWorksSection() {
  const navigate = useNavigate();

  const steps = [
    {
      number: '01',
      title: '비즈니스 정보 입력',
      description: '업종, 타겟 고객, 제품/서비스 정보를 간단히 입력하세요',
      icon: 'ri-edit-line'
    },
    {
      number: '02', 
      title: 'AI 분석 및 설계',
      description: 'AI가 입력된 정보를 분석하여 최적의 마케팅 퍼널을 자동으로 설계합니다',
      icon: 'ri-cpu-line'
    },
    {
      number: '03',
      title: '퍼널 커스터마이징',
      description: '생성된 퍼널을 검토하고 필요에 따라 세부사항을 조정할 수 있습니다',
      icon: 'ri-tools-line'
    },
    {
      number: '04',
      title: '실행 및 최적화',
      description: '퍼널을 실행하고 실시간 데이터를 바탕으로 지속적인 최적화를 진행합니다',
      icon: 'ri-rocket-line'
    }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            간단한 4단계로 완성
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            복잡한 마케팅 퍼널을 누구나 쉽게 만들 수 있도록 직관적인 프로세스를 제공합니다
          </p>
        </div>

        <div className="relative">
          {/* 연결선 */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-teal-200 transform -translate-y-1/2"></div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative text-center">
                <div className="bg-white border-4 border-teal-200 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-6 relative z-10">
                  <i className={`${step.icon} text-2xl text-teal-600`}></i>
                </div>
                <div className="bg-teal-600 text-white text-sm font-bold px-3 py-1 rounded-full inline-block mb-4">
                  {step.number}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <button 
            onClick={() => navigate('/funnel-generator')}
            className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            지금 시작하기
          </button>
        </div>
      </div>
    </section>
  );
}
